module.exports = __webpack_public_path__ + "assets/images/spor_fm_tv3_logo_v2_1.826fa4c73b1eed9047ea099d96c6c226.png";